import { render, staticRenderFns } from "./RandomCard.vue?vue&type=template&id=1a4b9766&scoped=true&"
import script from "./RandomCard.vue?vue&type=script&lang=js&"
export * from "./RandomCard.vue?vue&type=script&lang=js&"
import style0 from "./RandomCard.vue?vue&type=style&index=0&id=1a4b9766&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4b9766",
  null
  
)

export default component.exports